import styled from 'styled-components';
import theme from '@lib/theme';

const { colors } = theme;

export const CarouselOuterWrapper = styled.div`
  padding: 40px;
  width: calc(100% - 80px);
  position: relative;
`;

export const CarouselItem = styled.div`
  flex: 0 0 ${({ width }) => `${width}%`};
  cursor: pointer;
  width: ${({ width }) => `${width}%`};
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CarouselContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  z-index: 2;
`;

export const CarouselInnerImage = styled.img`
  width: calc(100% - 20px) !important;
  ${({ active }) => active && `border: 2px solid ${colors.navyGray}`};
  aspect-ratio: 1;
  margin: 0px !important;
`;

export const Carousel = styled.div`
  width: 100%;
  transform: ${({ currentIndex, moveValue }) => `translateX(-${currentIndex * moveValue}%)`};
  display: flex;
  transition: transform 0.5s ease;
`;

export const CarouselControls = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0px;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CarouselControl = styled.div`
  background: none;
  border: none;
  font-size: 24px;
  color: #000;
  cursor: pointer;
  img {
    height: 30px;
  }
`;
